import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerhireinhadapsar() {



  const cardData = {
"keyword": "Tempo Traveller hire in Hadapsar Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Tempo Traveller hire in Hadapsar, Pune for family trips, corporate travel, weddings, airport transfers, school tours, and outstation group journeys. Our fleet includes 9, 12, 14, 17, 20, and 26-seater Tempo Travellers with AC, pushback seats, spacious interiors, and experienced drivers familiar with Hadapsar, Magarpatta, Kharadi, and Pune highway routes. We ensure safe, comfortable, and punctual group travel with doorstep pickup from Hadapsar, Amanora, Magarpatta City, and surrounding areas.",

"topPlaces": [
{
"title": "Panhala Fort",
"description":
"Panhala Fort is a historic hill fort near Kolhapur known for Maratha history, scenic viewpoints, and trekking. It is a great heritage group travel destination from Pune."
},
{
"title": "Jawhar",
"description":
"Jawhar is a tribal hill station known for waterfalls, forts, and Warli art culture. It is a peaceful offbeat group travel destination from Pune."
},
  {
"title": "Bhimashankar Wildlife Sanctuary",
"description":
"Bhimashankar Wildlife Sanctuary is a rich biodiversity zone in the Western Ghats known for trekking trails, dense forests, and the famous Jyotirlinga temple. It is a popular nature and spiritual group travel destination from Pune."
},
{
"title": "Velas Beach",
"description":
"Velas Beach is a clean and quiet Konkan beach famous for Olive Ridley turtle conservation and eco-tourism. It is ideal for peaceful group trips and nature tours from Pune."
},
{
"title": "Tadoba National Park",
"description":
"Tadoba National Park is one of Maharashtra’s best tiger reserves known for wildlife safaris, forests, and adventure experiences. It is a popular long-distance group tour destination from Pune."
},

{
"title": "Satara Kaas Pathar",
"description":
"Satara Kaas Pathar is a UNESCO flower valley famous for seasonal blooms, scenic landscapes, and monsoon beauty. It is a top nature group tour destination from Pune."
},
{
"title": "Ratanwadi",
"description":
"Ratanwadi is a small village near Bhandardara known for Ratangad Fort trekking and natural beauty. It is popular for adventure group trips from Pune."
},
{
"title": "Harihar Fort",
"description":
"Harihar Fort is a unique rock-cut fort famous for its steep staircase and trekking challenge. It is a popular adventure group trekking destination from Pune."
},
{
"title": "Kalsubai Peak",
"description":
"Kalsubai Peak is the highest peak in Maharashtra known for trekking, sunrise views, and adventure tourism. It is ideal for group trekking trips from Pune."
},
{
"title": "Rajmachi Fort",
"description":
"Rajmachi Fort is a historic fort between Lonavala and Karjat known for trekking routes, caves, and monsoon beauty. It is a favorite group trekking destination from Pune."
}
],



services: [
  {
    name: "14 Seater Tempo Traveller Hadapsar",
    description: "14 seater Tempo Traveller Hadapsar service provides comfortable transportation for airport transfers, corporate travel, sightseeing tours, family outings, and outstation journeys. Spacious seating and luggage space ensure smooth travel experiences suitable for medium-sized passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient 14 seater traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller Hadapsar",
    description: "17 seater Tempo Traveller Hadapsar service offers spacious transportation for employee outings, pilgrimage journeys, educational tours, family vacations, and tourist travel. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for larger passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Hadapsar Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "20 Seater Tempo Traveller Hadapsar",
    description: "20 seater Tempo Traveller Hadapsar service provides reliable transportation for corporate events, airport transfers, wedding functions, office outings, and group travel requirements. Spacious interiors and luggage capacity ensure comfortable journeys suitable for medium and large passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Hadapsar Pune. Flexible booking options allow convenient 20 seater traveller reservations."
  },
  {
    name: "Tempo Traveller for Magarpatta City",
    description: "Tempo Traveller for Magarpatta City service offers dependable transportation for corporate travel, airport transfers, employee movement, sightseeing tours, and family journeys. Spacious seating and smooth travel performance ensure comfortable experiences suitable for IT professionals and group passengers. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from offices, homes, hotels, and commercial areas across Magarpatta City Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller for Amanora Park Town",
    description: "Tempo Traveller for Amanora Park Town service provides reliable transportation for family outings, office travel, airport transfers, weddings, and outstation journeys. Spacious seating and comfortable interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Amanora Park Town Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller for Corporate Hadapsar",
    description: "Tempo Traveller for corporate Hadapsar service offers professional transportation for business meetings, office outings, conferences, employee travel, and executive journeys. Spacious seating and smooth travel performance ensure comfortable experiences suitable for office teams and corporate passengers. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from offices, hotels, commercial locations, and business hubs across Hadapsar Pune. Flexible booking options allow convenient corporate traveller reservations."
  },
  {
    name: "Tempo Traveller for IT Employees Hadapsar",
    description: "Tempo Traveller for IT employees Hadapsar service provides dependable transportation for employee movement, office shuttle services, airport transfers, company outings, and business travel. Spacious seating and comfortable interiors ensure smooth journeys suitable for IT professionals and executive teams. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from offices, homes, hotels, and IT locations across Hadapsar Pune. Flexible booking options allow convenient IT employee traveller reservations."
  },
  {
    name: "Tempo Traveller for Wedding Hadapsar",
    description: "Tempo Traveller for wedding Hadapsar service offers stylish transportation for bridal parties, wedding guests, family members, and marriage event travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding ceremonies and celebrations. Professional drivers ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient wedding traveller reservations."
  },
  {
    name: "Tempo Traveller for Airport Pickup Hadapsar",
    description: "Tempo Traveller for airport pickup Hadapsar service provides reliable transportation for tourists, business travelers, wedding groups, and family passengers traveling to and from airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, and Pune Airport across Hadapsar Pune. Flexible booking options allow convenient airport traveller reservations."
  },
  {
    name: "Tempo Traveller for Outstation Hadapsar",
    description: "Tempo Traveller for outstation Hadapsar service offers dependable long-distance transportation for Goa tours, pilgrimage journeys, family vacations, sightseeing trips, and tourist travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient outstation traveller reservations."
  },
  {
    name: "Hadapsar to Shirdi Tempo Traveller",
    description: "Hadapsar to Shirdi Tempo Traveller service provides comfortable transportation for Sai Baba darshan tours, pilgrimage journeys, family trips, and spiritual group travel from Hadapsar Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Hadapsar to Mumbai Tempo Traveller",
    description: "Hadapsar to Mumbai Tempo Traveller service offers reliable long-distance transportation for corporate travel, sightseeing journeys, airport transfers, family trips, and tourist travel. Spacious seating and smooth expressway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Hadapsar Pune. Flexible booking options allow convenient Mumbai traveller reservations."
  },
  {
    name: "Hadapsar to Lonavala Tempo Traveller",
    description: "Hadapsar to Lonavala Tempo Traveller service provides comfortable hill station transportation for sightseeing tours, family vacations, office outings, and weekend trips from Hadapsar Pune. Spacious interiors and smooth expressway travel ensure pleasant journeys suitable for tourist and corporate groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Hadapsar Pune. Flexible booking options allow convenient Lonavala traveller reservations."
  },
  {
    name: "Hadapsar to Mahabaleshwar Tempo Traveller",
    description: "Hadapsar to Mahabaleshwar Tempo Traveller service offers dependable transportation for hill station vacations, sightseeing tours, family outings, and tourist travel from Hadapsar Pune. Spacious seating and smooth ghat road travel ensure comfortable journeys suitable for family and corporate groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "Hadapsar to Goa Tempo Traveller",
    description: "Hadapsar to Goa Tempo Traveller service provides premium long-distance transportation for beach vacations, sightseeing tours, bachelor trips, and family holidays from Hadapsar Pune. Spacious seating and luggage capacity ensure smooth highway journeys suitable for tourist and group travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Goa route. Pickup services are available from homes, offices, hotels, and residential locations across Hadapsar Pune. Flexible booking options allow convenient Goa traveller reservations."
  },
  {
    name: "Luxury Tempo Traveller Hadapsar",
    description: "Luxury Tempo Traveller Hadapsar service offers premium transportation for weddings, corporate events, airport transfers, sightseeing tours, and family vacations. Spacious luxury interiors and elegant seating ensure smooth travel experiences suitable for executive passengers and tourist groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Hadapsar Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "AC Tempo Traveller Hadapsar",
    description: "AC Tempo Traveller Hadapsar service provides premium air-conditioned transportation for business travel, educational tours, airport transfers, office outings, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Hadapsar Pune. Flexible booking options allow convenient AC traveller reservations."
  },
  {
    name: "Non AC Tempo Traveller Hadapsar",
    description: "Non AC Tempo Traveller Hadapsar service offers affordable transportation for educational tours, local sightseeing, office travel, school trips, and group journeys. Spacious seating and smooth travel ensure comfortable experiences suitable for budget-friendly travel requirements. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Hadapsar Pune. Flexible booking options allow convenient non AC traveller reservations."
  },
  {
    name: "Affordable Tempo Traveller Hadapsar",
    description: "Affordable Tempo Traveller Hadapsar service provides economical transportation for family outings, school trips, office travel, sightseeing tours, weddings, and local or outstation journeys. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient affordable traveller reservations."
  },
  {
    name: "Tempo Traveller Hire Kharadi Nearby",
    description: "Tempo Traveller hire Kharadi nearby service offers dependable transportation for airport transfers, office outings, sightseeing tours, family functions, and outstation travel. Spacious seating and smooth travel performance ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, IT parks, and residential areas across Kharadi Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller Hire Viman Nagar Nearby",
    description: "Tempo Traveller hire Viman Nagar nearby service provides reliable transportation for airport travel, office outings, educational tours, sightseeing journeys, and family functions. Spacious seating and luggage capacity ensure smooth travel experiences suitable for local and long-distance journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, Pune Airport, and commercial areas across Viman Nagar Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller for Group Travel Hadapsar",
    description: "Tempo Traveller for group travel Hadapsar service provides spacious transportation for educational tours, tourist travel, office outings, sightseeing journeys, and pilgrimage trips. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Hadapsar Pune. Flexible booking options allow convenient group travel traveller reservations."
  },
  {
    name: "Tempo Traveller for Family Trip Hadapsar",
    description: "Tempo Traveller for family trip Hadapsar service offers dependable transportation for holiday vacations, sightseeing journeys, pilgrimage tours, and group travel with relatives and family members. Spacious seating and luggage space ensure smooth travel experiences suitable for local and outstation family trips. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Hadapsar Pune. Flexible booking options allow convenient family trip traveller reservations."
  },
  {
    name: "Tempo Traveller Per KM Hadapsar",
    description: "Tempo Traveller per km Hadapsar service provides flexible and economical transportation for airport transfers, sightseeing tours, business travel, educational trips, and local group journeys. Spacious seating and comfortable interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Hadapsar Pune. Flexible booking options allow convenient per km traveller reservations."
  }
],

tableData: [
  ["14 Seater Tempo Traveller Hadapsar", "17 Seater Tempo Traveller Hadapsar"],
  ["20 Seater Tempo Traveller Hadapsar", "Tempo Traveller for Magarpatta City"],
  ["Tempo Traveller for Amanora Park Town", "Tempo Traveller for Corporate Hadapsar"],
  ["Tempo Traveller for IT Employees Hadapsar", "Tempo Traveller for Wedding Hadapsar"],
  ["Tempo Traveller for Airport Pickup Hadapsar", "Tempo Traveller for Outstation Hadapsar"],
  ["Hadapsar to Shirdi Tempo Traveller", "Hadapsar to Mumbai Tempo Traveller"],
  ["Hadapsar to Lonavala Tempo Traveller", "Hadapsar to Mahabaleshwar Tempo Traveller"],
  ["Hadapsar to Goa Tempo Traveller", "Luxury Tempo Traveller Hadapsar"],
  ["AC Tempo Traveller Hadapsar", "Non AC Tempo Traveller Hadapsar"],
  ["Affordable Tempo Traveller Hadapsar", "Tempo Traveller Hire Kharadi Nearby"],
  ["Tempo Traveller Hire Viman Nagar Nearby", "Tempo Traveller for Group Travel Hadapsar"],
  ["Tempo Traveller for Family Trip Hadapsar", "Tempo Traveller Per KM Hadapsar"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller Hire in Hadapsar Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller hire service in Hadapsar Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate tours, family trips, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller hire in Hadapsar Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Tempo Traveller hire service in Hadapsar Pune operates 24 hours for airport transfers, employee transportation, weddings, pilgrimage tours, corporate outings, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, office outings, pilgrimage journeys, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for office teams, family groups, wedding travel, tourists, and employee transportation."
      },
      {
        WhyChooseheading: "Quick Pickup Service in Hadapsar & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Hadapsar, Magarpatta, Amanora, Fursungi, Mundhwa, Kharadi, Wanowrie, and Pune Airport for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller hire in Hadapsar Pune?", answer: "Tempo Traveller hire service in Hadapsar Pune provides comfortable group transportation for corporate travel, family tours, weddings, and outstation journeys." },
    { question: "Is Tempo Traveller booking available 24 hours in Hadapsar?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller hire service in Hadapsar Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book Tempo Traveller for outstation travel from Hadapsar?", answer: "Yes, customers can book Tempo Travellers for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Hadapsar Pune." },
    { question: "Do you provide Tempo Travellers for corporate events in Hadapsar?", answer: "Yes, Aaradhya Travels provides Tempo Traveller hire service for corporate meetings, office outings, conferences, and employee transportation in Hadapsar." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller online in Hadapsar Pune?", answer: "Yes, customers can easily book Tempo Traveller hire service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for weddings, family vacations, and group tours." },
    { question: "Are Tempo Traveller hire charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller hire service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, corporate events, and peak travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Kulkarni",
    feedback:
      "Aaradhya Travels arranged a Tempo Traveller hire in Hadapsar Pune for our group outing, and the experience was very smooth. The vehicle was clean, spacious, and made local travel very comfortable for everyone.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Jadhav",
    feedback:
      "Tempo Traveller hire in Hadapsar Pune through Aaradhya Travels worked perfectly for our family trip. The journey was well managed, and everyone could travel together without any inconvenience.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Hire in Hadapsar Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/tempo-traveller-hire-in-hadapsar.jpg",
  "description": "Book Tempo Traveller hire in Hadapsar Pune with Aaradhya Travels for corporate travel, IT employees, weddings, airport transfers, family trips, and outstation journeys. Available in 14, 17, and 20 seater tempo travellers for Magarpatta City, Amanora Park Town, and nearby areas.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4011"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/tempo-traveller-hire-in-hadapsar"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Tempo Traveller Hire in Hadapsar Pune | Corporate & IT Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Tempo Traveller in Hadapsar Pune with Aaradhya Travels. Affordable 14, 17, and 20 seater tempo traveller available for Magarpatta City, Amanora Park Town, IT companies, corporate travel, weddings, airport pickup, and outstation trips."
  />

  <meta
    name="keywords"
    content="14 seater tempo traveller Hadapsar, 17 seater tempo traveller Hadapsar, 20 seater tempo traveller Hadapsar, Tempo traveller for Magarpatta City, Tempo traveller for Amanora Park Town, Tempo traveller for corporate Hadapsar, Tempo traveller for IT employees Hadapsar, Tempo traveller for wedding Hadapsar, Tempo traveller for airport pickup Hadapsar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerhireinhadapsar;